"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _store = _interopRequireDefault(require("./store.js"));
//@ts-check

/**
 * @param {string} name
 * @returns {string}
 */
var genStyleId = function genStyleId(name) {
  if (name === void 0) {
    name = "c";
  }
  return name + _store["default"].counter++ + "_";
};
var _default = exports["default"] = genStyleId;
module.exports = exports.default;